import Vue from "vue";
import Vuex from "vuex";
import identityModule from "./identity";
import demandesModule from "./demandesListe";
import demandeModule from "./demandeEditee";
import loaderModule from "./loader";
import errorModule from "./error";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    demandes: demandesModule,
    demandeEditee: demandeModule,
    identite: identityModule,
    loader: loaderModule,
    error: errorModule,
  },
});
